// Primary neutrals
export var neutrals = {
    900: '#0F1114',
    850: '#25282E',
    800: '#31353D',
    750: '#3F434A',
    700: '#5D6066',
    650: '#717479',
    600: '#86898D',
    550: '#8E9093',
    500: '#9A9B9C',
    400: '#A9AAAA',
    300: '#BCBDBC',
    200: '#D0D1D0',
    100: '#E8E8E8',
    50: '#F0F0F0',
    25: '#F5F5F5',
    0: '#FFFFFF',
};
// Primary / interactive
export var primary = {
    900: '#00337f',
    800: '#0347A1',
    700: '#075BC3',
    600: '#0969D9',
    500: '#0b76f0',
    400: '#3E9AF5',
    300: '#62B3F9',
    200: '#9CDCFF',
    100: '#CDEDFF',
    50: '#E2F5FF',
};
// Feedback
export var red = {
    900: '#AE0C1A',
    800: '#D30E1F',
    700: '#E31527',
    500: '#EA2839',
    400: '#F5767D',
    300: '#F4A9A7',
    200: '#F8C7C6',
    100: '#FCDEDD',
    50: '#FFF5F5',
};
export var yellow = {
    900: '#726909',
    800: '#ACA345',
    700: '#D1C653',
    500: '#F6E962',
    400: '#F8ED81',
    300: '#FAF2A1',
    200: '#FBF5BF',
    100: '#FDF9D3',
    50: '#FEFBE6',
};
export var green = {
    900: '#156019',
    800: '#2E7D32',
    700: '#388E3C',
    500: '#43A047',
    400: '#66BB6A',
    300: '#81C784',
    200: '#A7D8A9',
    100: '#C6E6C7',
    50: '#DAEFDB',
};
export var blue = {
    900: '#0E455B',
    800: '#19617f',
    700: '#0E97BF',
    500: '#03ceff',
    400: '#5DDCFF',
    300: '#99E5FF',
    200: '#C5F0FF',
    100: '#D8F5FF',
    50: '#E7F9FF',
};
//# sourceMappingURL=spotPrimitives.js.map